import { createContext, useContext, useEffect, useState } from "react";
import { PRODUCTS, BEST_SELLERS } from "@/data/site";

const computeBest = (list) =>
  [...list]
    .filter((p) => p.available)
    .sort((a, b) => {
      const da = a.oldPrice ? 1 - a.price / a.oldPrice : 0;
      const db = b.oldPrice ? 1 - b.price / b.oldPrice : 0;
      return db - da;
    })
    .slice(0, 10)
    .map((p) => p.id);

const ProductsContext = createContext({
  products: PRODUCTS,
  bestSellerIds: BEST_SELLERS,
  live: false,
});

export const useProducts = () => useContext(ProductsContext);

// Sayfa açılışında Shopify'dan canlı ürün/stok çeker; başarısız olursa
// pakete gömülü son senkron verisiyle çalışmaya devam eder.
export const ProductsProvider = ({ children }) => {
  const [state, setState] = useState({
    products: PRODUCTS,
    bestSellerIds: BEST_SELLERS,
    live: false,
  });

  useEffect(() => {
    let cancelled = false;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/products`)
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then((data) => {
        if (!cancelled && Array.isArray(data.products) && data.products.length > 0) {
          setState({
            products: data.products,
            bestSellerIds: computeBest(data.products),
            live: data.source === "live",
          });
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return <ProductsContext.Provider value={state}>{children}</ProductsContext.Provider>;
};
